import React from 'react';
import { darken, lighten, makeStyles } from '@material-ui/core';
import { Bar, defaults } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT } from '../../constants';


const {color_nav_letter,color_nav,color_back}= COLORS_PROJECT;
defaults.global.defaultFontColor  = darken(color_back,1);

const options = {
    maintainAspectRatio: false,
    responsive: true,
    title:{
        display:true,
        text:'Acumulado horas Alertas por día',
        fontSize:20,
        fontColor: darken(color_nav,0.45),
    },
    legend:{
        display:true,
        position:'top',
        labels:{
            fontColor: darken(color_nav_letter,1),
        },
    },
    scales:{
        xAxes: [{
            gridLines:{
                color: color_back,
            }
        }],
        yAxes: [{
            ticks: { min: 0 },
            scaleLabel: {
                display: true,
                labelString: 'Horas'
            },
            gridLines:{
                color: color_back,
            }
        }],
    },
}

const useStyles = makeStyles((theme) => ({
    sizeChart: {
        width: '100%',
        height: '250px',
        backgroundColor: lighten(color_back, 0.8),//lighten(theme.palette.primary.main,0.5),
    },
}));


export const BarChartGroup = () => {
    const classes= useStyles();
    const {data} = useSelector(state => state.print)
    const {2:dataAlarms=[]}=data

    const arrData = dataAlarms.acu_horas_dia || []
    const dates =  [...new Set(arrData.map(v => v.fecha))].sort();
    const alarms = [...new Set(arrData.map(v => v.nivel))].sort();

    const {colorPoints,nameAlerts} = useSelector(state => state.auth) //nameColors
    const arrColors = colorPoints.split(",")
    //const arrNames = nameColors.split(",")
    const arrNamesAlerts = nameAlerts.split(",")

    const Levels = {
        1: arrNamesAlerts[0],
        2: arrNamesAlerts[1],
        3: arrNamesAlerts[2],
    }

    const dataSets = alarms.map(alarm => ({

        label: Levels[alarm],
        data: arrData
          .filter((data) => data.nivel === alarm)
          .map((data) => {
            const time = data.acum_horas.split(':');
            const hours = Number(time[0]);
            const minutes = Number(time[1]);
            return {
              x: data.fecha,
              y: hours + (minutes / 60)
            };
          }),
        backgroundColor: () => {
            if (alarm === 1) {
                return arrColors[1]
            } else if (alarm === 2) {
                return arrColors[2]
            } else if (alarm === 3) {
                return arrColors[3]
            }
        },
        borderColor: () => {
            if (alarm === 1) {
                return darken(arrColors[1],0.4)
            } else if (alarm === 2) {
                return darken(arrColors[2],0.4)
            } else if (alarm === 3) {
                return darken(arrColors[3],0.4)
            }
        },
        borderWidth: 1,
        hoverBackgroundColor: () => {
            if (alarm === 1) {
                return lighten(arrColors[1],0.1)
            } else if (alarm === 2) {
                return lighten(arrColors[2],0.1)
            } else if (alarm === 3) {
                return lighten(arrColors[3],0.1)
            }
        },
        hoverBorderColor: () => {
            if (alarm === 1) {
                return lighten(arrColors[1],0.4)
            } else if (alarm === 2) {
                return lighten(arrColors[2],0.4)
            } else if (alarm === 3) {
                return lighten(arrColors[3],0.4)
            }
        },
    }))

    const dataCHart = {
        labels: dates,
        datasets: dataSets
    }
    return (
        <>
            <div className={classes.sizeChart}>
                <Bar data={dataCHart} options={options}/>
            </div>
        </>
    )
}
